/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { StatsGetResponse } from './StatsGetResponse';
import {
    StatsGetResponseFromJSON,
    StatsGetResponseFromJSONTyped,
    StatsGetResponseToJSON,
} from './StatsGetResponse';

/**
 * 
 * @export
 * @interface GetStats200Response
 */
export interface GetStats200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStats200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStats200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {StatsGetResponse}
     * @memberof GetStats200Response
     */
    result: StatsGetResponse;
}

/**
 * Check if a given object implements the GetStats200Response interface.
 */
export function instanceOfGetStats200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStats200ResponseFromJSON(json: any): GetStats200Response {
    return GetStats200ResponseFromJSONTyped(json, false);
}

export function GetStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStats200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': StatsGetResponseFromJSON(json['result']),
    };
}

export function GetStats200ResponseToJSON(value?: GetStats200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': StatsGetResponseToJSON(value.result),
    };
}

